export default __webpack_public_path__ + "static/media/moneyhash_card.157584d6.svg";